import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Card, CardContent, CardHeader } from "@mui/material";

import { DisplayField } from "../../../util/DisplayField";
import { MapSlider } from "./MapSlider";

type MapSliderWithDescriptionProps = {
  event: TerraShieldEvent;
  aoiList: TerraShieldEventAoi[];
};
export const MapSliderWithDescription: React.FC<MapSliderWithDescriptionProps> = ({ event, aoiList }) => {
  const { t } = useTranslation();

  useEffect(() => {}, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={8} sm={10} md={4} sx={{ height: "510px" }}>
        <Card sx={{ height: "100%" }}>
          <CardHeader title="Before and after event" />

          <CardContent style={{ paddingTop: "0" }}>
            <DisplayField
              label={t("emergencyMonitoring.description")}
              value="These two synchronized maps placed side by side, enabling detailed examination of geographical
              regions. Left Map: Provides a baseline view of the area, such as the pre-event state or a
              reference dataset. Right Map: Highlights changes, such as the post-event surface or processed
              imagery (provided by Maxar) for deeper insights. Each map displays clearly marked polygons representing zones of
              interest. These zones help you identify and focus on specific areas for further analysis. The
              interactive slider between the maps allows you to dynamically compare changes by sliding back
              and forth to reveal subtle differences or patterns in real time. Whether you're analyzing
              environmental impacts, land use changes, or infrastructure developments, this tool provides a
              powerful and intuitive way to visualize and understand spatial relationships and changes over
              time."
            />
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={12} md={8}>
        <MapSlider event={event} aoiList={aoiList} />
      </Grid>
    </Grid>
  );
};
